import { Component, ComponentFactoryResolver, ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { DtmService } from 'src/app/services/dtm.service';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { Dtm, getDtm } from 'src/app/shared/enum/dtm';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { HeaderContent } from 'src/app/shared/model/headerContent';
import { NutritionTable } from 'src/app/shared/model/nutrition-table';
import { ShopWindow } from 'src/app/shared/model/shop-window';
import { ShopWindowItem } from 'src/app/shared/model/shop-window-item';
import { ShopWindowManager } from 'src/app/shared/model/shop-window-manager';
import { CatalogService } from 'src/app/shared/services/catalog.service';
import { DiscountModalService } from 'src/app/shared/services/discount-modal.service';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { ShopWindowService } from 'src/app/shared/services/shop-window.service';
import { environment } from 'src/environments/environment';

const PLAN_CLASSIFICATION = 'monitore-clientes';

@Component({
    selector: 'pme-monitore-shop-window',
    templateUrl: './monitore-shop-window.component.html',
    styleUrls: ['./monitore-shop-window.component.scss'],
    standalone: false
})
export class MonitoreShopWindowComponent implements OnInit {
  //Variáveis de conteúdo do Shop Window
  headerContent: HeaderContent;
  tableNutritionContent: NutritionTable;
  productListingFooter: string[] = [];

  plans: Array<ShopWindowItem> = [];
  plansByPeriodicty: { [key: string]: ShopWindowItem[] } = {};

  // Variáveis de query params
  coupon: any;
  userId: any;
  businessId: any;
  ref: string;
  internalReference: any;
  checksum: any;
  checksumData: { ref: any; internalReference: any; cs: any; };

  // Controle do Switch
  selectedToggle: number = 0;

  classificationsGetted: number = 0;
  purchaseOrigin: string;
  submitting: boolean;
  periodicityList: string[];

  currentPlans: ShopWindowItem[] = [];
  legalNotes: string[];

  constructor(
    public catalogService: CatalogService,
    private discountModalService: DiscountModalService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public dtmService: DtmService,
    public dialog: MatDialog,
    private elementRef: ElementRef,
    private cookieService: CookieService,
    private shopWindowService: ShopWindowService,
    private resolver: ComponentFactoryResolver
  ) {
    this.openDialogSpinner();

    this.clearStorage();

    this.getParameters();

    this.dtmService.customLoaded([]);
    this.dtmService.pageLoaded(Dtm.MeuPacote, this.sessionStorageService.getIsLogged(), getDtm(Dtm.MeuPacote, PLAN_CLASSIFICATION));
    this.dtmService.sendPageLoadEvent();

    const validatedMitigation = this.sessionStorageService.getValidatedMitigation();

    this.getProducts(PLAN_CLASSIFICATION, validatedMitigation, (items: ShopWindowItem[]) => {
      this.plans = items.filter(item => !item.disable);
      this.handleProductsLoadDtm();
      this.closeDialogSpinner();
      this.getPlansByPeriodicity();
    });
  }

  getPlansByPeriodicity() {
    this.plansByPeriodicty = this.plans.reduce((acc, plan) => {
      const periodicity = plan.product.periodicity;
      if (!acc[periodicity]) {
        acc[periodicity] = [];
      }
      acc[periodicity].push(plan);
      return acc;
    }, {});

    this.periodicityList = Object.keys(this.plansByPeriodicty);

    this.onSelectionChanged(0);
  }

  handleProductsLoadDtm() {
    this.dtmService.productsLoaded(
      this.plans.map((plan) => (
        { 'classificationName': plan.product.classificationName, 'identifier': plan.product.identifier, 'value': plan.totalValue }))
    );

    this.dtmService.customLoaded(['ProdImpression', 'OverlayImpression']);
    this.dtmService.ruleChange('ProdImpression');
    this.dtmService.sendPageLoadEvent('ProdImpression');

  }

  getProducts(classification: string, validatedMitigation: any, callback: (items: ShopWindowItem[]) => void): void {
    this.catalogService
      .getProductsByClassification(classification, this.userId, validatedMitigation, this.coupon, this.businessId, this.checksumData
      )
      .subscribe(
        (shopWindow: ShopWindow) => {
          callback(shopWindow.shopWindowItems);
        },
        (error) => {
          throw new Error(
            `Erro ao obter produtos da classificação ${classification}: ${error.message}`,
          );
        },
      );
  }

  clearStorage() {
    this.selectedToggle = 0;
    this.sessionStorageService.clearSessionStorage(['oneClickPurchase']);
    this.sessionStorageService.clearSessionStorage(['purchaseOrigin']);
    this.sessionStorageService.clearSessionStorage(['oneClickPurchaseData']);
  }

  getParameters() {
    this.getProvisioningParametersFromSessionStorage();

    this.route.queryParams.subscribe((params) => {
      this.coupon = params.coupon;
      if (this.coupon) {
        sessionStorage.setItem('coupon', this.coupon);
      }
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
        this.setProvisioningParametersOnSessionStorage();
      }

      if (params.redirectUrl) {
        sessionStorage.setItem('successRedirectUrl', params.redirectUrl);
      }

      // Obtem parametros de checksum
      if (params.cs) {
        if (params.ref) {
          try {
            // Obtem user e business id do parametro ref em base64
            this.ref = atob(params.ref);
            const [refUserId, refBusinessId] = this.ref.split(':');

            if (refUserId) {
              this.userId = refUserId;
            }
            if (refBusinessId) {
              this.businessId = refBusinessId;
            }
            this.setProvisioningParametersOnSessionStorage();
          } catch (err) { }

        }

        if (params.internalReference) {
          this.internalReference = params.internalReference;
        }

        this.checksum = params.cs;
        this.checksumData = {
          ref: this.ref,
          internalReference: this.internalReference,
          cs: this.checksum
        };

        // Remove query params
        this.router.navigate([], {
          queryParams: {
            'cs': null,
            'ref': null,
            'internalReference': null
          },
          queryParamsHandling: 'merge'
        });
      }
    });
  }

  ngOnInit(): void {
    this.loadShopWindowContent();
    this.discountModalService.discountModalConfig.subscribe((newDiscountModalConfig) => {
      try {
        let discountModalConfig = JSON.parse(newDiscountModalConfig);
        if (discountModalConfig && discountModalConfig.timeToActivateShopWindow) {
          setTimeout(() => {
            if (this.router.url.indexOf('meu-plano') > -1) {
              this.discountModalService.setReachedTheModalTime(true);
            }

          }, discountModalConfig.timeToActivateShopWindow * 1000);
        }
      } catch (err) { }

    });
  }

  setProvisioningParametersOnSessionStorage() {
    this.sessionStorageService.setUserIdAndBusinessId(this.userId, this.businessId);

    if (this.userId && this.businessId) {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  loadShopWindowContent() {
    this.shopWindowService.getShopWindow(PLAN_CLASSIFICATION).subscribe((shopWindow: any) => {
      let shopWindowManager = new ShopWindowManager(shopWindow);
      this.headerContent = shopWindowManager.header;
      this.tableNutritionContent = shopWindowManager.nutritionTable;
      this.productListingFooter = shopWindowManager.productListing.footer || [];
      this.legalNotes = shopWindowManager.legalNotes || [];
    });
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: '400px',
      panelClass: 'pme-dialog-loading-panel',
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }

  closeDialogSpinner() {
    this.dialog.closeAll();
  }

  onSelectionChanged(selectedIndex: number) {
    this.selectedToggle = selectedIndex;
    this.currentPlans = this.plansByPeriodicty[this.periodicityList[selectedIndex]] || [];
  }

  openErrorDialog(dialogData, enableProducts: ShopWindowItem[], productIdentifier) {
    const data = DialogData.fromPreset(dialogData, { enableProducts });
    const content = data.errorMessage;
    const errorDetail = data.errorDetail;

    this.dialog.open(DialogAlertComponent, {
      disableClose: dialogData === 'checksum' ? true : false,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    // Analytics
    this.dtmService.customErrorLoaded(['error'], {
      errorDetail: errorDetail || productIdentifier,
      errorMessage: content,
    });
  }

  onChoosePlan() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.dtmService.sendSydleCustomEvent("Scroll-Monitore", {
      businessId: this.businessId || null,
      userId: this.userId || null,
      jorneyMappingEvent: "Scroll-Monitore",
    });
  }

  navigate(i: number) {
    this.submitting = true;

    this.handlePackageClick(i);

    let selectedPlan = this.currentPlans[i];


    // Se existe uma targetURL no sessionStorage, usa-a pra navegar
    const targetUrl = sessionStorage.getItem("targetUrl");
    if (
      targetUrl &&
      targetUrl !== "" &&
      !targetUrl.includes("meu-pacote") &&
      !targetUrl.includes(PLAN_CLASSIFICATION)
    ) {
      this.router.navigate([targetUrl]);
    } else {
      this.router.navigate(["../identificacao"], { relativeTo: this.route });
    }
    this.sessionStorageService.setProduct(
     selectedPlan.product.identifier
    );
    this.sessionStorageService.setClassification(
      selectedPlan.product.classificationIdentifier
    );
    this.sessionStorageService.setClassification(
      selectedPlan.product.classificationName
    );
  }

  handlePackageClick(i: number) {
    let plan = this.currentPlans[i];

    // Adobe Analytics

      this.discountModalService.setClickedOnPackages(true);
      this.dtmService.customLoaded(["ProdClick", "OverlayProdClick"]);
      this.dtmService.productsLoaded([
        {
          classificationName: plan.product.classificationName,
          identifier: plan.product.identifier,
          value: plan.totalValue
        },
      ]);
      window.setTimeout(() => "", 500);
      this.dtmService.ruleChange("prodClick");
      this.dtmService.sendPageLoadEvent("prodClick");

  }

}
